
import Component from 'vue-class-component';
import Vue from 'vue';
import stores from '@/store/core/RootStore';
import LocaleSwitch from '@/components/LocaleSwitch.vue';
import { Watch } from 'vue-property-decorator';

@Component({
  name: 'DefaultHeader',
  components: { LocaleSwitch },
})
export default class DefaultHeader extends Vue {
  contextValue = '';

  get profileOptions() {
    return [
      {
        label: this.$t('header.menu.logout'),
        value: 'exit',
        icon: 'arrow-to-the-right',
      },
    ];
  }

  get userName() {
    return stores.user.info?.name || stores.user.info?.fullName || '';
  }

  @Watch('contextValue')
  fn(val: any) {
    switch (val.value) {
      case 'exit':
        stores.user.LOGOUT();
        this.$router.push({ name: 'auth-login-index' });
        break;
    }
  }
}
